// A focused <input type="number"> increments/decrements its value on mouse-wheel
// (Firefox and older Chromium still do this; Chromium dropped it around v13x).
// For identity fields like Document No / Registration Year that is silent data
// corruption: the user types a number, scrolls the page, and the value changes
// under the cursor without them noticing.
//
// Blurring the input (rather than preventDefault) stops the mutation while still
// letting the wheel scroll the page — an unfocused number input ignores the
// wheel entirely. We deliberately do NOT test `event.target`: the wheel is
// dispatched to whatever element is under the cursor, which for our fields is
// usually the wrapper div, not the input itself.
//
// Registered once at app boot so it covers every number field in the app (plain
// inputs and MUI TextFields alike) rather than each form remembering its own
// onWheel guard.
if (typeof document !== "undefined") {
  document.addEventListener(
    "wheel",
    () => {
      const active = document.activeElement;
      if (active instanceof HTMLInputElement && active.type === "number") {
        active.blur();
      }
    },
    { passive: true }
  );
}
